import { Component, HostListener, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { InvoiceService } from 'src/app/services/invoice.service';
import { HelpersService } from 'src/app/services/helpers.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-workshop-jobcard-create-collection',
  templateUrl: './workshop-jobcard-create-collection.component.html',
  styleUrls: ['./workshop-jobcard-create-collection.component.scss']
})
export class WorkshopJobcardCreateCollectionComponent {

  @Input() sku: any = {};

  public collectionName: string = '';
  public saving: boolean = false;
  public errorMessage: string = '';

  constructor(
    public activeModal: NgbActiveModal,
    private invoiceService: InvoiceService,
    private helpersService: HelpersService,
    private translate: TranslateService
  ) { }


  createCollection() {    
    if (!this.collectionName || this.collectionName.trim() !== '') {
      this.errorMessage = '';
      this.saving = true;
      var data = {
        collectionName: this.collectionName,
        partnerID: this.helpersService.getPartnerId()
      }
      this.invoiceService.addProductCollection(data).subscribe((response) => {
        if (this.sku && this.sku.InternalProductID && response.productCollection && response.productCollection.id) {
          this.addSKUToCollection(response.productCollection);
        } else {
          this.saving = false;
          this.activeModal.close({});
        }
      }, err => {
        this.saving = false;
        console.log(err)
        if(err && err.error && err.error.message && err.error.message == 'COLLECTION_ALREADY_EXISTS') {
          this.errorMessage = this.translate.instant('bikeshop.workshop.jobcard.quote.collection_exists');
        }
      });
    }
  }

  addSKUToCollection(collection) {
    var data = {
      PartnerID: this.helpersService.getPartnerId(),
      ProductCollectionID: collection.id,
      InternalProductID: this.sku.InternalProductID,
    };
    this.invoiceService.addProductCollectionLink(data).subscribe((result) => {
          this.saving = false;
          this.activeModal.close({});
    });
  }

  @HostListener('document:keydown.enter', ['$event'])
  handleEnter(event: KeyboardEvent) {
    this.createCollection();
  }

}
